export default {"src":"/_next/static/media/missing_avatar.49e85643.svg","height":454,"width":454};